import { request } from "./http";
import { buildListQuery } from "./query";

export const listarClientes = (params) =>
  request(`clientes?${buildListQuery(params)}`);
export const crearCliente = (data) =>
  request("clientes", {
    method: "POST",
    body: JSON.stringify({ ...data, catalog_form: "complete" }),
  });
export const obtenerCliente = (id) => request(`clientes/${id}?perfil=all`);
export const actualizarCliente = (id, data) =>
  request(`clientes/${id}`, {
    method: "PUT",
    body: JSON.stringify({ ...data, catalog_form: "complete" }),
  });
export const eliminarCliente = (id) =>
  request(`clientes/${id}`, { method: "DELETE" });
